class TimeEntryUpdatesModalController {
  constructor(AuthenticationService, $http, $uibModalInstance, $rootScope){
    "ngInject";

    this.$http = $http;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
    this.timeEntriesThatNeedReasons = this.$uibModalInstance.timeEntriesThatNeedReasons;
    this.defaultReasons = AuthenticationService.user.lateEntryReasons;
    this.selectedDefaultReason = 0;
    this.MOD_TYPE_LABELS = {
      'new': 'Late Entry',
      'change': 'Modified'
    };
  }

  getModType(type) {
    return this.MOD_TYPE_LABELS[type] || type;
  }

  populateReasons() {
    this.timeEntriesThatNeedReasons.forEach(entry => {
      entry.reason = this.selectedDefaultReason.value;
    });
  }

  save() {
    if (!this.areAllReasonsValid()) {
      return;
    }

    this.$uibModalInstance.close();
  }



  areAllReasonsValid() {
    return this.timeEntriesThatNeedReasons.every(entry =>
      entry.reason && entry.reason.trim().length > 0
    );
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  };

}

export default TimeEntryUpdatesModalController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/time-entry-updates/time-entry-updates.controller.js